import Spinner from './Spinner';

interface LoadingOverlayProps {
    isLoading: boolean;
}

export default function LoadingOverlay({isLoading}: LoadingOverlayProps) {
    if (!isLoading) {
        return null;
    }

    return (
        <div
            className="position-fixed d-flex justify-content-center align-items-center"
            style={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
                zIndex: 1050,
            }}
        >
            <Spinner size="lg"/>
        </div>
    );
}
